import React from 'react';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import { redirectToMaintenance } from 'Helpers/Redirect';
import { Authentication } from 'Views/Authentication';

export const PasswordResetExperimental = () => {
  const { homeResource } = useHomeContext();

  const passwordResetRelationship = homeResource.withRelationship(fr.relationships.resetPasswordExperimental.name, (rel) => rel, () => null);

  // Bail if you don't have the passwordReset relationship
  React.useEffect(() => {
    if (!passwordResetRelationship) {
      redirectToMaintenance();
    }
  }, [passwordResetRelationship]);

  return <Authentication url={passwordResetRelationship.link('related').url()} />;
};
